import React from 'react'
import store from '../../../redux/store'
import DeleteBookingModal from '../components/list/delete-booking-modal/delete-booking-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openDeleteBookingModal = ({ id, handleConfirm, handleError, handleAbort }) => {
  const getComponent = (close) => {
    return (
      <DeleteBookingModal
        open
        id={id}
        store={store}
        handleConfirm={() => {
          close()
          handleConfirm()
        }}
        handleAbort={() => {
          close()
          handleAbort()
        }}
        handleError={handleError} />
    )
  }

  renderElement(getComponent)

}

export default openDeleteBookingModal
